import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import { Star } from 'lucide-react';

// index.tsx'ten ayrıştırıldı — landing "Reviews" bölümü
export default function Reviews({ L, feedbackAverage, feedbackTotal, featuredFeedbacks }: any) {
  const { locale, brandName } = useLocale();
  if (!feedbackTotal || feedbackTotal <= 0) return null;
  return (
    <>
        <section id="yorumlar" className="py-16 md:py-24 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-12">
              <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#FFB020] uppercase tracking-widest font-semibold mb-6">
                {L.reviews.badge}
              </div>
              <h2
                className="reveal reveal-delay-1 text-3xl md:text-4xl font-black text-white mb-6"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.reviews.titlePrefix} <span className="gradient-text">{locale === "tr" ? "Diyor?" : "Say?"}</span>
              </h2>
              <div className="reveal reveal-delay-2 inline-flex items-center gap-3 glass-panel rounded-2xl px-6 py-3">
                <span className="text-3xl font-black text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                  {feedbackAverage.toFixed(1)}
                </span>
                <div className="text-left">
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <Star
                        key={s}
                        size={16}
                        className={feedbackAverage >= s - 0.25 ? 'text-[#FACC15] fill-[#FACC15]' : 'text-gray-600'}
                      />
                    ))}
                  </div>
                  <p className="text-gray-400 text-xs mt-0.5">{feedbackTotal} {L.reviews.countSuffix}</p>
                </div>
              </div>
            </div>

            {featuredFeedbacks.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {featuredFeedbacks.map((fb, i) => (
                  <div
                    key={fb.id}
                    className={`reveal reveal-delay-${(i % 3) + 1} glass-panel gradient-border rounded-2xl p-6 text-left`}
                  >
                    <div className="flex gap-0.5 mb-3">
                      {[1, 2, 3, 4, 5].map((s) => (
                        <Star
                          key={s}
                          size={15}
                          className={fb.rating >= s ? 'text-[#FACC15] fill-[#FACC15]' : 'text-gray-600'}
                        />
                      ))}
                    </div>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4">“{fb.comment}”</p>
                    <div className="flex items-center gap-2">
                      <span className="w-8 h-8 rounded-full bg-gradient-to-br from-[#F59300] to-[#FFB020] flex items-center justify-center text-white text-xs font-bold">
                        PP
                      </span>
                      <div>
                        <p className="text-white text-xs font-bold">{L.reviews.anonymousUser}</p>
                        <p className="text-gray-500 text-[10px]">
                          {new Date(fb.createdAt).toLocaleDateString(locale === 'tr' ? 'tr-TR' : 'en-US', { year: 'numeric', month: 'long' })}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
    </>
  );
}
